import { useScanListener } from "@blackfisk/vue/composables/useScanListener";
import { useDialog } from "primevue/usedialog";

import QuickLogin from "@/components/QuickLogin.vue";

export const useQuickLogin = (): void => {
  const { listen: scanListen } = useScanListener();
  const dialog = useDialog();
  const onOpenQuickLogin = (userId: number, checksum: string): void => {
    dialog.open(QuickLogin, {
      props: {
        header: "Quick Login",
        style: {
          width: "50vw",
          "max-width": "50vw",
        },
        breakpoints: {
          "960px": "66vw",
          "640px": "90vw",
        },
        closable: false,
        dismissableMask: true,
        modal: true,
        draggable: true,
      },
      data: {
        userId,
        checksum,
      },
    });
  };
  scanListen(
    {
      USER_LOGIN: (scan) => {
        if (scan.type === "USER_LOGIN") {
          const userId = scan.meta.userId;
          const checksum = scan.meta.checksum;
          onOpenQuickLogin(userId, checksum);
        }
      },
    },
    {
      priority: 0,
      termination: false,
    },
  );
};
